import { Link } from "react-router-dom";
import useUserStore from "../../context/useUserStore";

/** Navigation card component for the admin dashboard. */
function NavCard({ to, title, description, testId }) {
  return (
    <Link
      to={to}
      data-testid={testId}
      className="block bg-white border-2 border-charcoal rounded-2xl p-6 shadow-[4px_4px_0_rgba(43,39,36,0.12)] hover:-translate-y-0.5 transition-transform group"
    >
      <h3 className="font-display text-xl text-charcoal uppercase group-hover:text-teal transition-colors">
        {title}
      </h3>
      <p className="font-body text-ink/70 text-sm mt-1">{description}</p>
    </Link>
  );
}

/**
 * Dashboard — Admin home page with navigation cards to management sections.
 */
export default function Dashboard() {
  const currentUser = useUserStore((state) => state.currentUser);

  return (
    <main data-testid="admin-dashboard-page" className="p-6">
      <header className="mb-8">
        <p className="font-heading tracking-[0.3em] text-teal-deep text-sm">ADMIN</p>
        <h1 className="font-display text-4xl text-charcoal uppercase">
          Welcome back{currentUser?.username ? `, ${currentUser.username}` : ""}.
        </h1>
        <p className="font-body text-ink/70 mt-1">Twin City Silver Bullet — Admin Dashboard</p>
      </header>

      <section aria-label="Management sections">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <NavCard
            to="/admin/menu"
            title="MENU MANAGEMENT"
            description="Add, edit, and deactivate menu items."
            testId="nav-card-menu"
          />
          <NavCard
            to="/admin/categories"
            title="CATEGORY MANAGEMENT"
            description="Organize menu items into categories."
            testId="nav-card-categories"
          />
          <NavCard
            to="/admin/vehicles"
            title="VEHICLE MANAGEMENT"
            description="Update vehicle status and current location."
            testId="nav-card-vehicles"
          />
          <NavCard
            to="/admin/events"
            title="EVENT MANAGEMENT"
            description="Create and manage upcoming events."
            testId="nav-card-events"
          />
          <NavCard
            to="/admin/app-share"
            title="APP / SHARE"
            description="Download the app QR code to print or display."
            testId="nav-card-app-share"
          />
        </div>
      </section>
    </main>
  );
}
